import { ICommissionCycle, IPayPeriod } from "@/Common/api/types/CommissionCycle";
import moment from "moment";

// Constants
import { COMPLETED } from "@/Constants/statuses";

export const findPartnerPayPeriod = ({
	commissionCycles = [],
	payPeriod = { nextCCId: "", previousCCId: "", _id: "" },
}: {
	commissionCycles?: ICommissionCycle[];
	payPeriod?: Partial<IPayPeriod>;
}) => {
	const { nextCCId, previousCCId, _id } = payPeriod ?? {};
	if (nextCCId || previousCCId) {
		const CC = commissionCycles.find((cycle) => cycle._id === (nextCCId ?? previousCCId));
		if (CC) {
			return CC.payPeriods.find((period) => period._id === _id);
		}
	}
	return null;
};

export const getCommissionCycleAndPayPeriodId = ({
	date,
	commissionCycles,
}: {
	date: string | moment.Moment | Date;
	commissionCycles: ICommissionCycle[];
}): { commissionCycleId: string; payPeriodId: string } => {
	const targetDate = moment(date);

	for (const cycle of commissionCycles) {
		for (const payPeriod of cycle.payPeriods) {
			const startDate = moment(payPeriod.startDate);
			const endDate = moment(payPeriod.endDate);

			if (targetDate.isBetween(startDate, endDate, undefined, "[]")) {
				return {
					commissionCycleId: cycle._id,
					payPeriodId: payPeriod._id,
				};
			}
		}
	}

	return { commissionCycleId: "", payPeriodId: "" };
};

export const isCurrentPPandCC = (args: { commissionCycleId: string; payPeriodId: string; commissionCycles: ICommissionCycle[] }) => {
	const { commissionCycleId, payPeriodId, commissionCycles } = args;
	const { commissionCycleId: currentCommissionCycle, payPeriodId: currentPayPeriod } = getCommissionCycleAndPayPeriodId({
		date: moment().toISOString(),
		commissionCycles,
	});

	return currentCommissionCycle === commissionCycleId && currentPayPeriod === payPeriodId;
};

function isStatusCompleted(status: string) {
	return status === COMPLETED;
}

export { isStatusCompleted };
